import React from 'react';
import styled from 'styled-components';
import PaymentText from '@catalogo/ui-americanas-mobile-payment-option';
import BrandCardAme from '@catalogo/ui-americanas-desktop-svg/brand-card-ame.svg';

export const SecondaryOption = ({ payment }) => {
  if (!payment) {
    return null;
  }

  return (
    <Text>
      <Svg>
        <BrandCardAme fill="#666" width="40px" height="11px" />
      </Svg>
      <Inline>
        <PaymentText payment={payment} showPrice />
      </Inline>
    </Text>
  );
};

const Svg = styled.div`
  width: 40px;
  margin-right: 10px;
  display: inline;
`;
const Text = styled.div`
  margin-top: 15px;
`;

const Inline = styled.span`
  > p {
    display: inline;
  }
`;
